import React, { useEffect, useState } from 'react';
import { Routes, Route, useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { useDownloadExcel } from 'react-export-table-to-excel';
import 'bootstrap/dist/css/bootstrap.min.css';
import Box from '@mui/material/Box';
import '../../style/HangManWinner.css';
import trophy from '../../image/Trophy.png';
import star from '../../image/star.png';
import Won from '../../Sounds/YouWon.mp3';
import BasicWinnerscreenHeader from '../../Header/BasicWinnerscreenHeader';
import {
  setProgress, setVolume, setAudio, setRounds, setSelectedRound, setbackgroundColor, setlogo, setfontColor, setTeamNames, setgameName,
  setTeam1bgColor,
  setTeam2bgColor,
  setButtonColor, setbackgroundImg,
  setPlaying
} from '../../Redux/action';
import firebase from '../../firebase';
import { getDatabase, ref, onValue, update } from "firebase/database";
import landscapeIcon from '../../image/landscape-icon.webp';
import { useMobileOrientation } from 'react-device-detect';
import * as XLSX from 'xlsx';
import axios from "axios";

const HangManWinnerScreen = ({ onNavigate }) => {
  const dispatch = useDispatch();
  const { orientation } = useMobileOrientation();
  const teamNames = useSelector(state => state.gameSettings.teamNames);
  const [result, setResult] = useState('');
  const [resultText, setResultText] = useState(''); // For result text based on points
  const [winSound, setWinSound] = useState(null);
  const backgroundColor = useSelector(state => state.backgroundColor.backgroundColor);
  const backgroundImg = useSelector(state => state.backgroundImg.backgroundImg);
  const buttonColor = useSelector(state => state.gameSettings.buttonColor);
  const code = localStorage.getItem('code');
  const mobile = useSelector(state => state.mobile.isMobile); // Correctly access isMobile
  const [data, setData] = useState(null);
  const [crowddata, setcrowdData] = useState(null);
  const backgroundStyle = backgroundImg
    ? {
      backgroundImage: `url(${backgroundImg})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      paddingLeft: mobile ? '15px' : '0', // 15px if mobile is true, 0 otherwise
      paddingRight: mobile ? '15px' : '0', // 15px if mobile is true, 0 otherwise
    }
    : {
      backgroundColor,
      paddingLeft: mobile ? '15px' : '0', // 15px if mobile is true, 0 otherwise
      paddingRight: mobile ? '15px' : '0', // 15px if mobile is true, 0 otherwise
    };
  const localization = useSelector((state) => state.localization.localization);
  const [isportrait, setIsportrait] = useState(false);
  const audio = useSelector((state) => state.audio.audio);
  const isPlayMode = window.location.href.includes("m=play");
  console.log(isPlayMode, "isPlayMode");
  const fullPath = window.location.pathname;
  const isCLParamPresent = fullPath.includes("m=cl");
  const isCRParamPresent = fullPath.includes("m=cr");
  console.log("Is m=cl present:", isCLParamPresent);
  const { clid: clid } = useParams();
  console.log(clid, "clid");
  const stopAudio = () => {
    if (audio) {
      audio.pause();
      audio.currentTime = 0; // Reset the audio position
      dispatch(setPlaying(false)); // Update Redux state
      console.log("audio paused and set to stopped");
    }
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://trivia-maker.firebaseio.com/ClassroomLeaderboard/${clid}.json`
        );
        const data = response.data;

        // Check if data is an array and extract the last element
        if (Array.isArray(data)) {
          const lastArray = data[data.length - 1];
          setData(lastArray);
          console.log(lastArray, "lastArray");
        } else {
          console.error("Fetched data is not an array:", data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (code) {
      fetchData();
    }
  }, [code]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://trivia-maker-tv.firebaseio.com/AppleTV/${code}.json`
        );
        const data = response.data;

        // Check if data is an array and extract the last element
        if (data.crowd) {
          const lastArray = data.crowd[0];
          setcrowdData(lastArray);
          console.log(lastArray, "lastArray");
        } else {
          console.error("Fetched data is not an array:", data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (code) {
      fetchData();
    }
  }, [code]);


  // Function to export to Excel
  //     const exportToExcel = () => {
  //       if (!data) {
  //         console.error("No data available to export.");
  //         return;
  //       }

  //       // Format the game played date
  //       const gamePlayedDate = new Date(data.startime).toLocaleString("en-US", {
  //         weekday: "long",
  //         year: "numeric",
  //         month: "long",
  //         day: "numeric",
  //         hour: "2-digit",
  //         minute: "2-digit",
  //         second: "2-digit",
  //       });

  //       // Accessing `scores`, `questionsarray`, and `participantsanswers` from `data`
  //       const scores = data.scores || [];
  //       const questionsarray = data.questionsarray || [];
  //       const participantsAnswers = data.participantsanwers || [];
  //       const connectedstudents = data.connectedstudents || [];

  //       // Decode the connected student names by replacing '+' with spaces
  //       const studentNames = connectedstudents.map(student => student.split("&")[0].replace(/\+/g, " "));

  //       // Filter scores to include only participants present in connectedstudents
  //       const filteredScores = scores.filter(score =>
  //         connectedstudents.some(student => student.includes(score.name))
  //       );

  //       // Prepare the StudentDetails with rankings based on score
  //       const sortedScores = [...filteredScores].sort((a, b) => b.score - a.score); // Sort scores in descending order

  //       const StudentDetails = sortedScores.map((item, index) => {
  //         const totalQuestions = questionsarray.length; // Total number of questions
  //         const correctAnswers = item.correctanswer || 0; // Correct answers by the participant

  //         // Calculate the total length of correct answers without spaces or special characters
  //         const totalCorrectAnswerLength = questionsarray.reduce((acc, question) => {
  //           const sanitizedAnswer = question.correctanswer.replace(/[^a-zA-Z0-9]/g, ""); // Remove spaces and special characters
  //           return acc + sanitizedAnswer.length;
  //         }, 0);

  //         // Initialize skipped count
  //         let skippedCount = 0;

  //         // Check each connected student's answers
  //         connectedstudents.forEach((name, i) => {
  //           // Extract the part of the name before the '&' character
  //           const sanitizedName = name.split('&')[0].trim(); // Get the name before '&' and trim any whitespace

  //           // Sanitize the student's name to match the key format in participantsAnswers
  //           const studentKey = name.replace(/&.*$/, "").replace(/ /g, "+"); // Remove team info and replace spaces with '+';

  //           // Check if participantsAnswers has an entry for this student
  //           const studentAnswers = participantsAnswers[index] && participantsAnswers[index][studentKey];
  //           const revealedCharacters = studentAnswers ? studentAnswers.revealedcharacters : "";

  //           // Check if the participant is skipped
  //           if (!studentAnswers || !revealedCharacters) {
  //             skippedCount+=1; // Increment skipped count if no entry or no revealed characters
  //           }
  //         });

  //         // Calculate incorrect answers based on sanitized lengths
  //         const incorrectAnswers = totalCorrectAnswerLength - correctAnswers;

  //         return {
  //           Rank: index + 1, // Rank based on sorted order
  //           "Participants name": item.name || "N/A",
  //           "Total Questions attempted": totalQuestions,
  //           Correct: correctAnswers,
  //           Incorrect: incorrectAnswers > 0 ? incorrectAnswers : 0, // Ensure non-negative value
  //           Skipped: skippedCount, // Set skipped questions count
  //           Score: item.score || 0,
  //           Accuracy: `${((correctAnswers / totalCorrectAnswerLength) * 100).toFixed(2)}%`, // Calculate accuracy
  //         };
  //       });



  //       // Prepare the GameDetails
  //   // Assuming data, filteredScores, and gamePlayedDate are defined as per your example
  // const totalQuestions = questionsarray.length; // Total number of questions
  // const totalParticipants = participantsAnswers.length; // Total number of participants

  // // Calculate accuracy as a percentage
  // const accuracy = totalQuestions > 0 ? ((totalParticipants / totalQuestions) * 100).toFixed(2) : 0;

  // // Set GameDetails
  // const GameDetails = [
  //   {
  //     "Game name": data.name,
  //     "Game Type": data.gametype,
  //     "Total Participants": filteredScores.length || 0, // Count participants after filtering
  //     Accuracy: `${accuracy}%`, // Set accuracy as a percentage
  //     "Game played date": gamePlayedDate,
  //   },
  // ];

  // console.log(GameDetails);


  //       const QuestionData = questionsarray.map((q, index) => {
  //         // Initialize the question data with a column for each student
  //         const questionData = {
  //           Question: q.question || "N/A",
  //           "Question Accuracy": "", // Placeholder for accuracy
  //           Correct: 0, // Initialize as 0
  //           Incorrect: 0, // Initialize as 0
  //           skipped: 0, // Initialize skipped as 0
  //           "Correct Answer": q.correctanswer || "N/A",
  //         };

  //         // Split the correct answer into unique characters, ignoring spaces
  //         const correctAnswerChars = new Set(q.correctanswer.toLowerCase().replace(/\s+/g, '').split(''));

  //         // Track if at least one student has the correct answer
  //         let anyStudentCorrect = false;

  //         // Add columns for each connected student's name
  //         connectedstudents.forEach((name, i) => {
  //           // Extract the part of the name before the '&' character
  //           const sanitizedName = name.split('&')[0].trim(); // Get the name before '&' and trim any whitespace

  //           // Sanitize the student's name to match the key format in participantsAnswers
  //           const studentKey = name.replace(/&.*$/, "").replace(/ /g, "+"); // Remove team info and replace spaces with '+';

  //           // Check if participantsAnswers has an entry for this student
  //           const studentAnswers = participantsAnswers[index] && participantsAnswers[index][studentKey];
  //           const revealedCharacters = studentAnswers ? studentAnswers.revealedcharacters : "";

  //           // Set revealed characters or empty if not available
  //           questionData[sanitizedName] = revealedCharacters || "";

  //           // Create a set of revealed characters, ignoring spaces and converting to lowercase
  //           const revealedCharsSet = revealedCharacters && revealedCharacters.trim() !== ""
  //             ? new Set(revealedCharacters.toLowerCase().replace(/\s+/g, '').split(',').map(char => char.trim()))
  //             : new Set(); // Create an empty set if revealedCharacters is empty

  //           // Check if the participant is skipped
  //           if (!studentAnswers || !revealedCharacters) {
  //             questionData.skipped = 1; // Mark as skipped if no entry or no revealed characters
  //           }

  //           // Check if all correct answer characters are revealed
  //           const allCorrectRevealed = [...correctAnswerChars].every(char => revealedCharsSet.has(char));

  //           // Update Correct and Incorrect fields based on the revealed characters
  //           if (allCorrectRevealed) {
  //             anyStudentCorrect = true; // At least one student has the correct answer
  //           }
  //         });

  //         // Set the overall Correct and Incorrect values based on any student's result
  //         questionData.Correct = anyStudentCorrect ? 1 : 0;
  //         questionData.Incorrect = anyStudentCorrect ? 0 : 1;

  //         // Set Question Accuracy based on Correct field
  //         questionData["Question Accuracy"] = questionData.Correct === 1 ? "100%" : "0%";

  //         return questionData;
  //       });


  //       // Convert each data set to a worksheet
  //       const worksheet1 = XLSX.utils.json_to_sheet(QuestionData);
  //       const worksheet2 = XLSX.utils.json_to_sheet(StudentDetails);
  //       const worksheet3 = XLSX.utils.json_to_sheet(GameDetails);

  //       // Create a workbook and append the worksheets
  //       const workbook = XLSX.utils.book_new();
  //       XLSX.utils.book_append_sheet(workbook, worksheet1, "Question Data");
  //       XLSX.utils.book_append_sheet(workbook, worksheet2, "Student Details");
  //       XLSX.utils.book_append_sheet(workbook, worksheet3, "Game Details");

  //       // Write the file and create a blob
  //       const xlsData = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  //       const blob = new Blob([xlsData], { type: "application/octet-stream" });

  //       // Trigger download
  //       const gameName = data.name; 
  //       const url = window.URL.createObjectURL(blob);
  //       const link = document.createElement("a");
  //       link.href = url;
  //       link.setAttribute("download", `${gameName}.xlsx`);
  //       document.body.appendChild(link);
  //       link.click();

  //       // Cleanup
  //       link.parentNode.removeChild(link);
  //       window.URL.revokeObjectURL(url);
  //     };
  const exportToExcel = () => {
    if (!data) {
      console.error("No data available to export.");
      return;
    }

    // Format the game played date
    const gamePlayedDate = new Date(data.startime).toLocaleString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });

    // Accessing `scores`, `questionsarray`, and `participantsanswers` from `data`
    const scores = data.scores || [];
    const questionsarray = data.questionsarray || [];
    const participantsAnswers = data.participantsanwers || [];
    const connectedstudents = data.connectedstudents || [];

    // Decode the connected student names by replacing '+' with spaces
    const studentNames = connectedstudents.map(student => student.split("&")[0].replace(/\+/g, " "));

    // Filter scores to include only participants present in connectedstudents
    const filteredScores = scores.filter(score =>
      connectedstudents.some(student => student.includes(score.name))
    );

    // Prepare the StudentDetails with rankings based on score
    const sortedScores = [...filteredScores].sort((a, b) => b.score - a.score); // Sort scores in descending order

    const StudentDetails = sortedScores.map((item, index) => {
      const totalQuestions = questionsarray.length; // Total number of questions
      const correctAnswers = item.correctanswer || 0; // Correct answers by the participant

      // Calculate the total length of correct answers without spaces or special characters
      const totalCorrectAnswerLength = questionsarray.reduce((acc, question) => {
        const sanitizedAnswer = question.correctanswer.replace(/[^a-zA-Z0-9]/g, ""); // Remove spaces and special characters
        return acc + sanitizedAnswer.length;
      }, 0);

      // Initialize skipped count
      let skippedCount = 0;

      // Check each connected student's answers
      connectedstudents.forEach((name, i) => {
        // Extract the part of the name before the '&' character
        const sanitizedName = name.split('&')[0].trim(); // Get the name before '&' and trim any whitespace

        // Sanitize the student's name to match the key format in participantsAnswers
        const studentKey = name.replace(/&.*$/, "").replace(/ /g, "+"); // Remove team info and replace spaces with '+';

        // Check if participantsAnswers has an entry for this student
        const studentAnswers = participantsAnswers[index] && participantsAnswers[index][studentKey];
        const revealedCharacters = studentAnswers ? studentAnswers.revealedcharacters : "";

        // Check if the participant is skipped
        if (!studentAnswers || !revealedCharacters) {
          skippedCount += 1; // Increment skipped count if no entry or no revealed characters
        }
      });

      // Calculate incorrect answers based on sanitized lengths
      const incorrectAnswers = totalCorrectAnswerLength - correctAnswers;

      return {
        Rank: index + 1, // Rank based on sorted order
        "Participants name": item.name || "N/A",
        "Total Questions attempted": totalQuestions,
        Correct: correctAnswers,
        Incorrect: incorrectAnswers > 0 ? incorrectAnswers : 0, // Ensure non-negative value
        Skipped: skippedCount, // Set skipped questions count
        Score: item.score || 0,
        Accuracy: `${((correctAnswers / totalCorrectAnswerLength) * 100).toFixed(2)}%`, // Calculate accuracy
      };
    });



    // Prepare the GameDetails
    // Assuming data, filteredScores, and gamePlayedDate are defined as per your example
    const totalQuestions = questionsarray.length; // Total number of questions
    const totalParticipants = participantsAnswers.length; // Total number of participants

    // Calculate accuracy as a percentage
    const accuracy = totalQuestions > 0 ? ((totalParticipants / totalQuestions) * 100).toFixed(2) : 0;

    // Set GameDetails
    const GameDetails = [
      {
        "Game name": data.name,
        "Game Type": data.gametype,
        "Total Participants": filteredScores.length || 0, // Count participants after filtering
        Accuracy: `${accuracy}%`, // Set accuracy as a percentage
        "Game played date": gamePlayedDate,
      },
    ];

    console.log(GameDetails);


    const QuestionData = questionsarray.map((q, index) => {
      // Initialize the question data with a column for each student
      const questionData = {
        Question: q.question || "N/A",
        "Question Accuracy": "", // Placeholder for accuracy
        Correct: 0, // Initialize as 0
        Incorrect: 0, // Initialize as 0
        skipped: 0, // Initialize skipped as 0
        "Correct Answer": q.correctanswer || "N/A",
      };

      // Split the correct answer into unique characters, ignoring spaces
      const correctAnswerChars = new Set(q.correctanswer.toLowerCase().replace(/\s+/g, '').split(''));

      // Track if at least one student has the correct answer
      let anyStudentCorrect = false;

      // Add columns for each connected student's name
      connectedstudents.forEach((name, i) => {
        // Extract the part of the name before the '&' character
        const sanitizedName = name.split('&')[0].trim(); // Get the name before '&' and trim any whitespace

        // Sanitize the student's name to match the key format in participantsAnswers
        const studentKey = name.replace(/&.*$/, "").replace(/ /g, "+"); // Remove team info and replace spaces with '+';

        // Check if participantsAnswers has an entry for this student
        const studentAnswers = participantsAnswers[index] && participantsAnswers[index][studentKey];
        const revealedCharacters = studentAnswers ? studentAnswers.revealedcharacters : "";

        // Set revealed characters or empty if not available
        questionData[sanitizedName] = revealedCharacters || "";

        // Create a set of revealed characters, ignoring spaces and converting to lowercase
        const revealedCharsSet = revealedCharacters && revealedCharacters.trim() !== ""
          ? new Set(revealedCharacters.toLowerCase().replace(/\s+/g, '').split(',').map(char => char.trim()))
          : new Set(); // Create an empty set if revealedCharacters is empty

        // Check if the participant is skipped
        if (!studentAnswers || !revealedCharacters) {
          questionData.skipped = 1; // Mark as skipped if no entry or no revealed characters
        }

        // Check if all correct answer characters are revealed
        const allCorrectRevealed = [...correctAnswerChars].every(char => revealedCharsSet.has(char));

        // Update Correct and Incorrect fields based on the revealed characters
        if (allCorrectRevealed) {
          anyStudentCorrect = true; // At least one student has the correct answer
        }
      });

      // Set the overall Correct and Incorrect values based on any student's result
      questionData.Correct = anyStudentCorrect ? 1 : 0;
      questionData.Incorrect = anyStudentCorrect ? 0 : 1;

      // Set Question Accuracy based on Correct field
      questionData["Question Accuracy"] = questionData.Correct === 1 ? "100%" : "0%";

      return questionData;
    });


    const worksheet1 = XLSX.utils.json_to_sheet(QuestionData);
    const worksheet2 = XLSX.utils.json_to_sheet(StudentDetails);
    const worksheet3 = XLSX.utils.json_to_sheet(GameDetails);

    // Function to add instructions to a worksheet
    const addInstructions = (worksheet, instructions) => {
      // Get the current number of rows in the worksheet
      const currentRowCount = XLSX.utils.sheet_to_json(worksheet).length;

      // Insert instructions after the 5th row (index 5)
      const instructionRowIndex = 5; // 5th row (0-based index)

      // Create an array of arrays for the instructions
      const instructionData = instructions.map(instruction => [instruction]);

      // Add the instructions to the worksheet
      XLSX.utils.sheet_add_aoa(worksheet, instructionData, { origin: { r: instructionRowIndex, c: 0 } });
    };

    // Define your instructions
    const questionInstructions = [
      "The data in this tab is calculated based on each individual round. Here’s how it works:",
      "Correct: If a student chooses all letters correctly for a particular round, they will receive +1 in this column.",
      "Skipped: If a student skips all letters in a particular round, they will receive +1 in this column.",
      "Incorrect: If a student selects any letter incorrectly in a particular round, the score for that round will be +1 in this column.", ,
      "Example:",
      "If a game has 3 rounds:",
      "A student who answers all letters correctly in 1 round will have Correct = 1 for that round.",
      "If they skip all letters in 1 round, Skipped = 1 for that round.", ,
      "Accuracy:",
      "Accuracy for Question Data is calculated as:",
      "If correct answer is one then 100% accuracy will set.",
      "if incorrect answer is 1 then 0% accuracy will set",
    ];

    const studentInstructions = [
      "The data in this tab is calculated based on the total rounds in the game. Here’s how it works:",
      "Correct: The total count of correct answers given by a student across all rounds.",
      "Incorrect: The total count of incorrect answers given by a student across all rounds.",
      "Skipped: If a student skips all letters in a particular round, it will be counted as +1 in this column.", ,
      "Note: If any letter in a round is skipped but others are attempted, it will not be counted in the Skipped column.", ,
      "Example:",
      "A student who answers all letters correctly in 2 rounds will have Correct = 2.",
      "If they skip all letters in 1 round, Skipped = 1.",
      "If they attempt but answer incorrectly in 1 round, Incorrect = 1.", ,
      "Accuracy:",
      "Accuracy for Student Details is calculated as:",
      "Total Correct Answers / Total Question Count * 100",
    ];

    const gameInstructions = [
      "The data in this tab is calculated based on the total rounds in the game. Here’s how it works:",
      "Accuracy for GameDetails:",
      "Accuracy for Game Details is calculates as",
      "total Round played / total rounds *100",
    ];
    // Add instructions to each worksheet
    addInstructions(worksheet1, questionInstructions);
    addInstructions(worksheet2, studentInstructions);
    addInstructions(worksheet3, gameInstructions);

    // Create a workbook and append the worksheets
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet1, "Question Data");
    XLSX.utils.book_append_sheet(workbook, worksheet2, "Student Details");
    XLSX.utils.book_append_sheet(workbook, worksheet3, "Game Details");

    // Write the file and create a blob
    const xlsData = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([xlsData], { type: "application/octet-stream" });

    // Trigger download
    const gameName = data.name;
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${gameName}.xlsx`);
    document.body.appendChild(link);
    link.click();

    // Cleanup
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const exportToExcelforCrowdmode = () => {

    // Format the game played date
    const gamePlayedDate = new Date(crowddata.startime).toLocaleString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });

    // Accessing `scores`, `questionsarray`, and `participantsanswers` from `data`
    if (!crowddata) {
      console.error("No data available to export.");
      return;
    }

    const scores = crowddata.scores || [];
    const questionsarray = crowddata.questionsarray || [];
    const participantsAnswers = crowddata.participantsanwers || [];
    const connectedstudents = crowddata.connectedstudents || [];

    const studentNames = connectedstudents.map(student => student.split("&")[0].replace(/\+/g, " "));
    const filteredScores = scores.filter(score =>
      connectedstudents.some(student => student.includes(score.name))
    );

    const sortedScores = [...filteredScores].sort((a, b) => b.score - a.score);
    const StudentDetails = sortedScores.map((item, index) => {
      const totalQuestions = questionsarray.length; // Total number of questions
      const correctAnswers = item.correctanswer || 0; // Correct answers by the participant

      console.log("Function started");

      // Calculate the total length of correct answers without spaces or special characters
      const totalCorrectAnswerLength = questionsarray.reduce((acc, question) => {
        const sanitizedAnswer = question.correctanswer.replace(/[^a-zA-Z0-9]/g, ""); // Remove spaces and special characters
        return acc + sanitizedAnswer.length;
      }, 0);


      // Initialize skipped count
      let skippedCount = 0;

      // Ensure participantsAnswers[index] is defined and contains valid data
      const participantsForRound = participantsAnswers[index] || {};

      // Check each connected student's answers
      connectedstudents.forEach((name) => {
        console.log(name, "student name");
        console.log(index, "current round index");

        // Extract the part of the name before the '&' character
        const studentKey = name.split('-')[1].split('&')[0].trim();

        // Retrieve this student's answers from participantsAnswers

        // If no entry exists for this student, or if revealedcharacters is empty, count as skipped
        const studentAnswers = participantsAnswers[index]?.[studentKey] || null; const revealedCharacters = studentAnswers?.revealedcharacters || "";
        // If studentAnswers exists but revealedcharacters is empty, count as skipped
        if (studentAnswers && !studentAnswers.revealedcharacters) {
          console.log(`No revealed characters for ${studentKey}, counting as skipped.`);
          skippedCount += 1;
        }

      });

      // Calculate incorrect answers based on sanitized lengths
      const incorrectAnswers = totalCorrectAnswerLength - correctAnswers;

      return {
        Rank: index + 1, // Rank based on sorted order
        "Participants name": item.name || "N/A",
        "Total Questions attempted": totalQuestions,
        Correct: correctAnswers,
        Incorrect: incorrectAnswers > 0 ? incorrectAnswers : 0, // Ensure non-negative value
        Skipped: skippedCount, // Set skipped questions count
        Score: item.score || 0,
        Accuracy: `${((correctAnswers / totalCorrectAnswerLength) * 100).toFixed(
          2
        )}%`, // Calculate accuracy
      };
    });

    console.log("function ended");

    // Prepare the GameDetails
    // Assuming data, filteredScores, and gamePlayedDate are defined as per your example
    const totalQuestions = questionsarray.length; // Total number of questions
    const totalParticipants = participantsAnswers.length; // Total number of participants

    // Calculate accuracy as a percentage
    const accuracy = totalQuestions > 0 ? ((totalParticipants / totalQuestions) * 100).toFixed(2) : 0;

    // Set GameDetails
    const GameDetails = [
      {
        "Game name": crowddata.name,
        "Game Type": crowddata.gametype,
        "Total Participants": filteredScores.length || 0, // Count participants after filtering
        Accuracy: `${accuracy}%`, // Set accuracy as a percentage
        "Game played date": gamePlayedDate,
      },
    ];

    console.log(GameDetails);


    const QuestionData = questionsarray.map((q, index) => {
      // Initialize the question data with a column for each student
      const questionData = {
        Question: q.question || "N/A",
        "Question Accuracy": "", // Placeholder for accuracy
        Correct: 0, // Initialize as 0
        Incorrect: 0, // Initialize as 0
        skipped: 0, // Initialize skipped as 0
        "Correct Answer": q.correctanswer || "N/A",
      };

      // Split the correct answer into unique characters, ignoring spaces
      const correctAnswerChars = new Set(q.correctanswer.toLowerCase().replace(/\s+/g, '').split(''));

      // Track if at least one student has the correct answer
      let anyStudentCorrect = false;

      // Add columns for each connected student's name
      connectedstudents.forEach((name, i) => {
        // Extract the part of the name before the '&' character
        const sanitizedName = name.split('&')[0].trim(); // Get the name before '&' and trim any whitespace
        const sanitizedforrevealedName = name.split('-')[1].split('&')[0].trim();


        // Check if participantsAnswers has an entry for this student
        const studentAnswers = participantsAnswers[index] && participantsAnswers[index][sanitizedforrevealedName];
        const revealedCharacters = studentAnswers ? studentAnswers.revealedcharacters : "";

        // Set revealed characters or empty if not available
        questionData[sanitizedName] = revealedCharacters || "";

        // Create a set of revealed characters, ignoring spaces and converting to lowercase
        const revealedCharsSet = revealedCharacters && revealedCharacters.trim() !== ""
          ? new Set(revealedCharacters.toLowerCase().replace(/\s+/g, '').split(',').map(char => char.trim()))
          : new Set(); // Create an empty set if revealedCharacters is empty

        // Check if the participant is skipped
        if (!studentAnswers || !revealedCharacters) {
          questionData.skipped = 1; // Mark as skipped if no entry or no revealed characters
        }

        // Check if all correct answer characters are revealed
        const allCorrectRevealed = [...correctAnswerChars].every(char => revealedCharsSet.has(char));

        // Update Correct and Incorrect fields based on the revealed characters
        if (allCorrectRevealed) {
          anyStudentCorrect = true; // At least one student has the correct answer
        }
      });

      // Set the overall Correct and Incorrect values based on any student's result
      questionData.Correct = anyStudentCorrect ? 1 : 0;
      questionData.Incorrect = anyStudentCorrect ? 0 : 1;

      // Set Question Accuracy based on Correct field
      questionData["Question Accuracy"] = questionData.Correct === 1 ? "100%" : "0%";

      return questionData;
    });


    const worksheet1 = XLSX.utils.json_to_sheet(QuestionData);
    const worksheet2 = XLSX.utils.json_to_sheet(StudentDetails);
    const worksheet3 = XLSX.utils.json_to_sheet(GameDetails);

    // Function to add instructions to a worksheet
    const addInstructions = (worksheet, instructions) => {
      // Get the current number of rows in the worksheet
      const currentRowCount = XLSX.utils.sheet_to_json(worksheet).length;

      // Insert instructions after the 5th row (index 5)
      const instructionRowIndex = 5; // 5th row (0-based index)

      // Create an array of arrays for the instructions
      const instructionData = instructions.map(instruction => [instruction]);

      // Add the instructions to the worksheet
      XLSX.utils.sheet_add_aoa(worksheet, instructionData, { origin: { r: instructionRowIndex, c: 0 } });
    };

    // Define your instructions
    const questionInstructions = [
      "The data in this tab is calculated based on each individual round. Here’s how it works:",
      "Correct: If a student chooses all letters correctly for a particular round, they will receive +1 in this column.",
      "Skipped: If a student skips all letters in a particular round, they will receive +1 in this column.",
      "Incorrect: If a student selects any letter incorrectly in a particular round, the score for that round will be +1 in this column.", ,
      "Example:",
      "If a game has 3 rounds:",
      "A student who answers all letters correctly in 1 round will have Correct = 1 for that round.",
      "If they skip all letters in 1 round, Skipped = 1 for that round.", ,
      "Accuracy:",
      "Accuracy for Question Data is calculated as:",
      "If correct answer is one then 100% accuracy will set.",
      "if incorrect answer is 1 then 0% accuracy will set",
    ];

    const studentInstructions = [
      "The data in this tab is calculated based on the total rounds in the game. Here’s how it works:",
      "Correct: The total count of correct answers given by a student across all rounds.",
      "Incorrect: The total count of incorrect answers given by a student across all rounds.",
      "Skipped: If a student skips all letters in a particular round, it will be counted as +1 in this column.", ,
      "Note: If any letter in a round is skipped but others are attempted, it will not be counted in the Skipped column.", ,
      "Example:",
      "A student who answers all letters correctly in 2 rounds will have Correct = 2.",
      "If they skip all letters in 1 round, Skipped = 1.",
      "If they attempt but answer incorrectly in 1 round, Incorrect = 1.", ,
      "Accuracy:",
      "Accuracy for Student Details is calculated as:",
      "Total Correct Answers / Total Question Count * 100",
    ];

    const gameInstructions = [
      "The data in this tab is calculated based on the total rounds in the game. Here’s how it works:",
      "Accuracy for GameDetails:",
      "Accuracy for Game Details is calculates as",
      "total Round played / total rounds *100",
    ];
    // Add instructions to each worksheet
    addInstructions(worksheet1, questionInstructions);
    addInstructions(worksheet2, studentInstructions);
    addInstructions(worksheet3, gameInstructions);

    // Create a workbook and append the worksheets
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet1, "Question Data");
    XLSX.utils.book_append_sheet(workbook, worksheet2, "Student Details");
    XLSX.utils.book_append_sheet(workbook, worksheet3, "Game Details");

    // Write the file and create a blob
    const xlsData = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([xlsData], { type: "application/octet-stream" });

    // Trigger download
    const gameName = crowddata.name;
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${gameName}.xlsx`);
    document.body.appendChild(link);
    link.click();

    // Cleanup
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  };
  useEffect(() => {
    // Stop any currently playing audio
    stopAudio();

    // Create the audio object for the "Won" audio
    const audioObj = new Audio(Won);
    setAudio(audioObj); // Set the new audio object in the state

    // Play the "Won" audio
    audioObj.play().catch((error) => {
      console.error('Audio play was interrupted:', error);
    });

    // Cleanup function to pause and reset the new audio when unmounting
    return () => {
      audioObj.pause();
      audioObj.currentTime = 0; // Reset the audio position
    };
  }, []);

  const determineWinner = (roundWinners) => {
    // Check if the URL contains 'm=play'
    // const isPlayMode = window.location.href.includes('m=play');

    // Filter out draws from the roundWinners
    const filteredWinners = roundWinners.filter(winner => winner.team !== 'Draw');

    // Count the number of rounds won by each team
    const teamWinCounts = filteredWinners.reduce((counts, winner) => {
      counts[winner.team] = (counts[winner.team] || 0) + 1;
      return counts;
    }, {});

    const teamEntries = Object.entries(teamWinCounts); // [['Team 1', 2], ['Team 2', 1]]

    if (teamEntries.length === 0) {
      // If no team won any rounds
      if (isPlayMode) {
        return ['You', "won with 0 points!"];
      }
      return [`${(teamNames || []).join(' and ')}`, "You tied with 0 points!"];
    } else if (teamEntries.length === 1) {
      // Only one team played or all wins belong to the same team
      const points = teamEntries[0][1];
      return isPlayMode
        ? ['You', `won with ${points} point${points > 1 ? 's' : ''}!`]
        : [`${teamEntries[0][0]}`, `You won with ${points} point${points > 1 ? 's' : ''}!`];
    }

    // Sort teams by win count in descending order
    teamEntries.sort((a, b) => b[1] - a[1]);

    const [topTeam, secondTeam] = teamEntries;
    if (topTeam[1] === secondTeam[1]) {
      // If there's a tie between the top two teams
      return isPlayMode
        ? ['You', `tied with ${topTeam[1]} points!`]
        : [`It's a Tie between ${topTeam[0]} and ${secondTeam[0]}`, `You tied with ${topTeam[1]} points!`];
    } else {
      // Top team wins with more points
      return isPlayMode
        ? ['You', `won with ${topTeam[1]} point${topTeam[1] > 1 ? 's' : ''}!`]
        : [`${topTeam[0]}`, `You won with ${topTeam[1]} point${topTeam[1] > 1 ? 's' : ''}!`];
    }
  };


  //   // Function to determine the winner based on round wins
  //   const determineWinner = (roundWinners) => {
  //     // Check if the URL contains 'm=play'
  //     const isPlayMode = window.location.href.includes('m=play');

  //     // Filter out draws from the roundWinners
  //     const filteredWinners = roundWinners.filter(winner => winner.team !== 'Draw');

  //     // Count the number of rounds won by each team
  //     const teamWinCounts = filteredWinners.reduce((counts, winner) => {
  //         counts[winner.team] = (counts[winner.team] || 0) + 1;
  //         return counts;
  //     }, {});

  //     const teamEntries = Object.entries(teamWinCounts); // [['Team 1', 2], ['Team 2', 1]]

  //     if (teamEntries.length === 0) {
  //         // If no team won any rounds and 'm=play' is in the URL
  //         if (isPlayMode) {
  //             return [`${teamNames[0]}`, "You won with 0 points!"];
  //         }
  //         return [`${teamNames.join(' and ')}`, "You tied with 0 points!"]; // No team won any rounds
  //     } else if (teamEntries.length === 1) {
  //         // Only one team played or all wins belong to the same team
  //         const points = teamEntries[0][1];
  //         return [`${teamEntries[0][0]}`, `You won with ${points} point${points > 1 ? 's' : ''}!`];
  //     }

  //     // Sort teams by win count in descending order
  //     teamEntries.sort((a, b) => b[1] - a[1]);

  //     const [topTeam, secondTeam] = teamEntries;
  //     if (topTeam[1] === secondTeam[1]) {
  //         // If there's a tie between the top two teams
  //         return [`It's a Tie between ${topTeam[0]} and ${secondTeam[0]}`, `You tied with ${topTeam[1]} points!`];
  //     } else {
  //         // Top team wins with more points
  //         return [`${topTeam[0]}`, `You won with ${topTeam[1]} point${topTeam[1] > 1 ? 's' : ''}!`];
  //     }
  // };


  useEffect(() => {
    if (code) {
      const database = getDatabase(); // Initialize the database
      const dbRef = ref(database, `AppleTV/${code}`); // Set reference to specific path
      let previousData;

      // Listen for data changes at the specified reference
      onValue(dbRef, (snapshot) => {
        const data = snapshot.val();
        if (data !== previousData) {
          console.log("Data updated:", data);
          previousData = data;

          // Check if command is 7010
          const command = data.command;
          if (command === '7010') {
            console.log("Command 7010 received");
            const roundWinners = localStorage.getItem('roundWinners');
            if (roundWinners) {
              const parsedWinners = JSON.parse(roundWinners);
              const [winningTeam, resultText] = determineWinner(parsedWinners);

              // Update winning team and result text in the database
              update(dbRef, {
                winningTeam: winningTeam,
                resultText: resultText,
              });
              console.log("Winning team and result text updated in database");

            } else {
              console.log("No round winners found");
            }
          }
        }
      });
    }
  }, [code, onNavigate]);

  useEffect(() => {
    const roundWinners = localStorage.getItem('roundWinners');
    if (roundWinners) {
      const parsedWinners = JSON.parse(roundWinners);
      const [resultText, pointsText] = determineWinner(parsedWinners);
      setResult(resultText);
      setResultText(pointsText);
    } else {
      // If no round winners are found, default message with team names
      if (isPlayMode) {
        setResult(`You`);
        setResultText("won with 0 points!");
      } else {
        setResult(`${(teamNames || []).join(' and ')}`);
        setResultText("You tied with 0 points!");
      }

    }
  }, [teamNames]); // Include teamNames as dependency

  // Animation for the trophy image
  useEffect(() => {
    const trophyImage = document.querySelector('.trophy');
    if (trophyImage) {
      trophyImage.classList.add('slide-in');
    }
  }, []);


  useEffect(() => {
    if (orientation === 'portrait') {
      // User is on a mobile device in portrait mode
      setIsportrait(true);
      console.log("Mobile portrait mode detected");
    } else {
      setIsportrait(false);
      console.log("Not mobile portrait mode");
    }
  }, [orientation]);

  return (
    <>
      {isportrait ? (
        <>
          <div
            style={{
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh',
              fontSize: '1.5rem',
              fontWeight: 'bolder',
              backgroundColor: '#27738e',
              color: 'white',
              display: 'flex',
              flexDirection: 'column',
              padding: '1.5vh'
            }}
          >
            <span className='mt-2 mb-4 p-3 '> To view this game, you will need to place your device in landscape mode</span>

            <div style={{ padding: '1.5vh' }}>
              <img src={landscapeIcon} alt="landscapeIcon" height={200} className="rotate-icon" />
            </div>
          </div>
        </>
      ) :
        (
          <>
            <BasicWinnerscreenHeader onNavigate={onNavigate} />


            <div className='hangman-winner-container' style={backgroundStyle}>

              <img src={trophy} alt='trophy' className='trophy' />

              {/* Left side stars */}
              <div className='star-group star-group-left'>
                <img src={star} alt='star' className='star left-middle-star' />
                <img src={star} alt='star' className='star small-star ' />
                <img src={star} alt='star' className='star big-star ' />
              </div>

              {/* Right side stars */}
              <div className='star-group star-group-right'>
                <img src={star} alt='star' className='star right right-middle-star' />
                <img src={star} alt='star' className='star right right-small-star' />
                <img src={star} alt='star' className='star right right-big-star' />
              </div>

              <Box className='hangman-winner-box'>
                <div className='CongratulationText bold-text'>{localization?.congratulations || "Congratulations!"}</div>
                <div className='teamText bold-text'>{result}</div> {/* Dynamic team result */}
                <div className='resultText bold-text'>{resultText}</div> {/* Dynamic result text based on points */}
              </Box>
              {isCLParamPresent || isCRParamPresent ? (
                <button
                  className="button"
                  style={{
                    backgroundColor: buttonColor,
                    color: 'white',
                    borderStyle: 'none',
                    fontSize: '1.5rem',
                    marginBottom: '80vh',
                    borderRadius: '10px',
                  }}
                  onClick={isCLParamPresent ? exportToExcel : exportToExcelforCrowdmode} // Pass function directly
                >
                  {localization?.export_results || "Export Results"}
                </button>
              ) : null}

            </div>
          </>
        )
      }
    </>
  );
}

export default HangManWinnerScreen;
